import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import React from 'react';
import DesktopDevPageDisplaySide300x250Gak from './gak/DesktopDevPageDisplaySide300x250';
import DesktopDevPageDisplaySide300x250Nitro from './nitro/DesktopDevPageDisplaySide300x250';
const DesktopDevPageDisplaySide300x250 = ({ safety ='off'  })=>{
    const isDaAds = useFlag('ads_da');
    if (isDaAds) {
        return /*#__PURE__*/ React.createElement(DesktopDevPageDisplaySide300x250Gak, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopDevPageDisplaySide300x250Nitro, {
        safety: safety
    });
};
DesktopDevPageDisplaySide300x250.displayName = 'DesktopDevPageDisplaySide300x250';
export default DesktopDevPageDisplaySide300x250;
